// AI Agents Registry
// This file exports all available AI agents

import SkripsiAgent from './SkripsiAgent/index.jsx'
import ArtikelAgent from './ArtikelAgent/index.jsx'
import MakalahAgent from './MakalahAgent/index.jsx'
import TrendingAgent from './TrendingAgent/index.jsx'
import GambarAgent from './GambarAgent/index.jsx'
import VideoAgent from './VideoAgent/index.jsx'
import BukuAgent from './BukuAgent/index.jsx'
import NovelAgent from './NovelAgent/index.jsx'
import BeritaAgent from './BeritaAgent/index.jsx'
import SearchAgent from './SearchAgent/index.jsx'
import WritingAgent from './WritingAgent/index.jsx'
import PPTAgent from './PPTAgent/index.jsx'
import ChartAgent from './ChartAgent/index.jsx'
import ResearchAgent from './ResearchAgent/index.jsx'
import PDFAgent from './PDFAgent/index.jsx'
import { BookOpen, FileText, GraduationCap, Image, Video, Book, Newspaper, Search, TrendingUp, PenTool, Presentation, BarChart3, FlaskConical, FileType, Feather } from 'lucide-react'
import { AGENT_TYPES } from '../constants/agentConfig.js'

// Available agents configuration
export const AVAILABLE_AGENTS = [
  {
    id: AGENT_TYPES.SEARCH,
    name: 'Search Agent',
    description: 'Menjawab pertanyaan dengan informasi berkualitas dari sumber web dan akademik yang terpercaya',
    icon: Search,
    component: SearchAgent,
    color: '#06b6d4' // cyan-500
  },
  {
    id: AGENT_TYPES.WRITING,
    name: 'Writing Agent',
    description: 'Editor dokumen AI dengan fitur editing, parafrase, dan berbagai tools penulisan cerdas',
    icon: PenTool,
    component: WritingAgent,
    color: '#7c3aed' // violet-600
  },
  {
    id: AGENT_TYPES.SKRIPSI,
    name: 'Skripsi Agent',
    description: 'Membuat draft skripsi lengkap dengan 25-40 ribu kata sesuai kaidah penulisan Indonesia',
    icon: BookOpen,
    component: SkripsiAgent,
    color: '#10b981' // emerald-500
  },
  {
    id: AGENT_TYPES.ARTIKEL,
    name: 'Artikel Agent',
    description: 'Membuat artikel web lengkap dengan 2500-4000 kata yang engaging dan informatif',
    icon: FileText,
    component: ArtikelAgent,
    color: '#3b82f6' // blue-500
  },
  {
    id: AGENT_TYPES.MAKALAH,
    name: 'Makalah Agent',
    description: 'Membuat makalah akademik lengkap dengan 10.000-15.000 kata sesuai standar penelitian',
    icon: GraduationCap,
    component: MakalahAgent,
    color: '#8b5cf6' // violet-500
  },
  {
    id: AGENT_TYPES.GAMBAR,
    name: 'Gambar Agent',
    description: 'Membuat gambar AI berkualitas tinggi dengan berbagai pilihan aspect ratio',
    icon: Image,
    component: GambarAgent,
    color: '#ec4899' // pink-500
  },
  {
    id: AGENT_TYPES.VIDEO,
    name: 'Video Agent',
    description: 'Membuat video AI dari teks atau gambar dengan kualitas tinggi dan berbagai opsi durasi',
    icon: Video,
    component: VideoAgent,
    color: '#f97316' // orange-500
  },
  {
    id: AGENT_TYPES.BUKU,
    name: 'Buku Agent',
    description: 'Membuat buku non-fiksi edukatif dengan 250-500 halaman, struktur sistematis, dan referensi valid',
    icon: Book,
    component: BukuAgent,
    color: '#f59e0b' // amber-500
  },
  {
    id: AGENT_TYPES.NOVEL,
    name: 'Novel Agent',
    description: 'Membuat novel berkualitas tinggi dengan 250-400 halaman, struktur plot profesional, dan elemen kejutan menarik',
    icon: Feather,
    component: NovelAgent,
    color: '#8b5cf6' // violet-500
  },
  {
    id: AGENT_TYPES.BERITA,
    name: 'Berita Agent',
    description: 'Membuat artikel berita aktual dan original dengan referensi dari 10-20 sumber portal berita terpercaya',
    icon: Newspaper,
    component: BeritaAgent,
    color: '#ef4444' // red-500
  },
  {
    id: AGENT_TYPES.TRENDING,
    name: 'Trending Agent',
    description: 'Deteksi trend terbaru di internet dengan filter tanggal dan region',
    icon: TrendingUp,
    component: TrendingAgent,
    color: '#f97316' // orange-500
  },
  {
    id: AGENT_TYPES.PPT,
    name: 'PPT Agent',
    description: 'Membuat rancangan presentasi PowerPoint lengkap dengan slide menarik, grafik, dan elemen visual',
    icon: Presentation,
    component: PPTAgent,
    color: '#9333ea' // purple-600
  },
  {
    id: AGENT_TYPES.CHART,
    name: 'Chart Agent',
    description: 'Membuat 5 jenis chart visual (Pie, Bar, Line, Doughnut, Area) dari data atau topik yang dapat didownload sebagai gambar',
    icon: BarChart3,
    component: ChartAgent,
    color: '#059669' // emerald-600
  },
  {
    id: AGENT_TYPES.RESEARCH,
    name: 'Research Agent',
    description: 'Membuat research paper komprehensif yang diterima secara akademik dengan visualisasi data dan dapat diexport ke PDF/PPT',
    icon: FlaskConical,
    component: ResearchAgent,
    color: '#dc2626' // red-600
  },
  {
    id: AGENT_TYPES.PDF,
    name: 'PDF Agent',
    description: 'Membaca dan menganalisis dokumen PDF, menjawab pertanyaan berdasarkan konten dokumen',
    icon: FileType,
    component: PDFAgent,
    color: '#ea580c' // orange-600
  },
  // Add more agents here
]

// Get agent by ID
export const getAgentById = (id) => {
  return AVAILABLE_AGENTS.find(agent => agent.id === id)
}

// Re-export AGENT_TYPES for backward compatibility
export { AGENT_TYPES }

// Backward compatibility aliases (deprecated - use AGENT_TYPES and AVAILABLE_AGENTS instead)
export const BOT_TYPES = AGENT_TYPES
export const AVAILABLE_BOTS = AVAILABLE_AGENTS

// Export individual agents
export { SkripsiAgent, ArtikelAgent, MakalahAgent, GambarAgent, VideoAgent, BukuAgent, NovelAgent, BeritaAgent, SearchAgent, TrendingAgent, WritingAgent, PPTAgent, ChartAgent, ResearchAgent, PDFAgent }